import apiRequest from './client';

// Rapport 'Tickets Gagnant' (portail company, Rapports > Tickets Gagnant) —
// groupe par bank. filter/scope = meme radio All/Group/Supervisor/Bank que les
// autres rapports (Terminal Rapport, Paris gagnants, cf. _scope_filter backend).
export const fetchWinningTicketsReport = ({
  dateFrom, dateTo, filter, scope, tirage, paymentStatus, searchBy,
}) => {
  const params = new URLSearchParams();
  params.set('date_from', dateFrom);
  params.set('date_to', dateTo);
  if (filter) params.set('filter', filter);
  if (scope) params.set('scope', scope);
  if (tirage && tirage !== '0') params.set('tirage', tirage);
  if (paymentStatus) params.set('payment_status', paymentStatus);
  if (searchBy) params.set('search_by', searchBy);
  return apiRequest(`/tickets/winning-tickets-report/?${params.toString()}`);
};
